import type { VisibilityScopeValue } from "../../../components/ui/VisibilityScope";
import type { MaterialCategory as MaterialCategoryCode } from "./material";

// Mirrors internal/engines/envelope_designer/models/api/material_category.go: the admin's category of the material
// library, the name in every language (the translations null = the English name), the admissible-condensate
// category of its materials that have none, and its visibility (hidden: its materials too, user side).
export type MaterialCategory = {
  code: MaterialCategoryCode;
  name: string;
  nameIt: string | null;
  nameDe: string | null;
  nameFr: string | null;
  nameEs: string | null;
  condCategory: string;
  visibility: VisibilityScopeValue;
  order: number;
};

// A category's / subcategory's code: lowercase letters, digits and hyphens (material_category_service.go).
export const CLASSIFICATION_CODE = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export type MaterialCategoryBody = Omit<MaterialCategory, "visibility" | "order">;

export type SearchMaterialCategoriesResponse = {
  items: MaterialCategory[];
  total: number;
};
